import { ReactNode } from "react";

interface VehicleProps {
  children: ReactNode;
}
export default function Vehicle({ children }: VehicleProps) {
  return (
    <div>
      <div className="flex items-center justify-evenly border border-paragraph p-2 text-paragraph rounded-lg hover:cursor-pointer hover:bg-primary hover:text-white hover:border-primary duration-500">
        {children}
      </div>
    </div>
  );
}
